package com.esoris.kmpmoout.features.expense.expense_form

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.esoris.kmpmoout.core.app_dummy.AppDummy
import com.esoris.kmpmoout.domaindata.expense.ExpenseRepository
import com.esoris.kmpmoout.navigation.NavManager
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ExpenseFormViewModel(
    private val navManager: NavManager,
    private val expenseRepository: ExpenseRepository,
) : ViewModel() {
    private val _uiState = MutableStateFlow(ExpenseFormUiState())
    val uiState: StateFlow<ExpenseFormUiState> = _uiState.asStateFlow()

    fun onEvent(event: ExpenseFormEvent) {
        when (event) {
            is ExpenseFormEvent.OnNavigateBack -> navManager.back()
            is ExpenseFormEvent.OnNavigateTo -> navManager.navigate(event.route)
            is ExpenseFormEvent.OnExpenseFormChange -> {
                val form = event.expenseForm

                _uiState.update { it.copy(expenseForm = form) }
                if(form.validateCount > 0){
                    validateForm(form)
                }
            }

            is ExpenseFormEvent.OnSaveNewExpense -> {
                if (!validateForm(event.expenseForm)) return

                val expense = event.expenseForm.toNewExpense(AppDummy.userId)

                viewModelScope.launch {
                    expenseRepository.insertExpense(expense)
                }

            }
        }
    }

    private fun validateForm(form: ExpenseForm): Boolean {

        val categoryError = when {
            form.category.isBlank() -> "Category is required"
            form.category.length < 3 -> "Category must be at least 3 characters"
            form.category.length > 50 -> "Category must be less than 50 characters"
            else -> null
        }

        val amountError = if(form.amount == 0L) "Amount is required" else null

        val noteError = null

        _uiState.update {
            it.copy(
                expenseForm = form.copy(
                    categoryError = categoryError,
                    amountError = amountError,
                    noteError = noteError,
                    validateCount = form.validateCount + 1
                )
            )
        }

        return categoryError == null && amountError == null && noteError == null

    }

    private fun resetExpenseForm() {
        _uiState.update {
            it.copy(
                expenseForm = ExpenseForm()
            )
        }
    }

}